/**
 * @flow
 * @relayHash 52aaefaf9e4e7e229aaa3bb3709418c0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type NavBar_viewer$ref = any;
type SearchResultBar_viewer$ref = any;
type Suggest_suggestSearch$ref = any;
type UserSection_viewer$ref = any;
export type HeaderLoaderQueryVariables = {|
  params?: ?string
|};
export type HeaderLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: NavBar_viewer$ref & UserSection_viewer$ref & SearchResultBar_viewer$ref
  |},
  +suggestSearch: ?{|
    +$fragmentRefs: Suggest_suggestSearch$ref
  |},
|};
export type HeaderLoaderQuery = {|
  variables: HeaderLoaderQueryVariables,
  response: HeaderLoaderQueryResponse,
|};
*/


/*
query HeaderLoaderQuery(
  $params: String
) {
  viewer {
    ...NavBar_viewer
    ...UserSection_viewer
    ...SearchResultBar_viewer_35PWgj
    id
  }
  suggestSearch {
    ...Suggest_suggestSearch
  }
}

fragment NavBar_viewer on Viewer {
  id
  isLogin
  endUserType
}

fragment SearchResultBarContent_viewer_35PWgj on Viewer {
  searchModel(params: $params) {
    count
  }
  searchItem(params: $params) {
    count
  }
  searchCatalog(params: $params) {
    count
  }
  searchNews(params: $params) {
    count
  }
}

fragment SearchResultBar_viewer_35PWgj on Viewer {
  ...SearchResultBarContent_viewer_35PWgj
}

fragment Suggest_suggestSearch on SuggestSearch {
  search(keyword: "") {
    productKeyword
    productType
  }
}

fragment UserMenu_viewer on Viewer {
  userId
  locale
  serverTime
  displayName
  companyName
  isLogin
  isBusiness
  isActiveBusiness
  buyer {
    approvalFlag
  }
  unreadMessageCount
}

fragment UserSection_viewer on Viewer {
  id
  userId
  isInternalIp
  isLogRocket
  isLogin
  isBusiness
  isActiveBusinessCart
  ...UserMenu_viewer
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "params",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "params",
    "variableName": "params"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "count",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HeaderLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NavBar_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "UserSection_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "SearchResultBar_viewer",
            "args": (v1/*: any*/)
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suggestSearch",
        "storageKey": null,
        "args": null,
        "concreteType": "SuggestSearch",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Suggest_suggestSearch",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HeaderLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isLogin",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endUserType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isInternalIp",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isLogRocket",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isBusiness",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActiveBusinessCart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "locale",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "serverTime",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "companyName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActiveBusiness",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "buyer",
            "storageKey": null,
            "args": null,
            "concreteType": "Buyer",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approvalFlag",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "unreadMessageCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchModel",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SearchModel",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchItem",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SearchModel",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchCatalog",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SearchCatalogResult",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchNews",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SearchNews",
            "plural": false,
            "selections": (v2/*: any*/)
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suggestSearch",
        "storageKey": null,
        "args": null,
        "concreteType": "SuggestSearch",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "search",
            "storageKey": "search(keyword:\"\")",
            "args": [
              {
                "kind": "Literal",
                "name": "keyword",
                "value": ""
              }
            ],
            "concreteType": "SuggestProduct",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "productKeyword",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "productType",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "HeaderLoaderQuery",
    "id": null,
    "text": "query HeaderLoaderQuery(\n  $params: String\n) {\n  viewer {\n    ...NavBar_viewer\n    ...UserSection_viewer\n    ...SearchResultBar_viewer_35PWgj\n    id\n  }\n  suggestSearch {\n    ...Suggest_suggestSearch\n  }\n}\n\nfragment NavBar_viewer on Viewer {\n  id\n  isLogin\n  endUserType\n}\n\nfragment SearchResultBarContent_viewer_35PWgj on Viewer {\n  searchModel(params: $params) {\n    count\n  }\n  searchItem(params: $params) {\n    count\n  }\n  searchCatalog(params: $params) {\n    count\n  }\n  searchNews(params: $params) {\n    count\n  }\n}\n\nfragment SearchResultBar_viewer_35PWgj on Viewer {\n  ...SearchResultBarContent_viewer_35PWgj\n}\n\nfragment Suggest_suggestSearch on SuggestSearch {\n  search(keyword: \"\") {\n    productKeyword\n    productType\n  }\n}\n\nfragment UserMenu_viewer on Viewer {\n  userId\n  locale\n  serverTime\n  displayName\n  companyName\n  isLogin\n  isBusiness\n  isActiveBusiness\n  buyer {\n    approvalFlag\n  }\n  unreadMessageCount\n}\n\nfragment UserSection_viewer on Viewer {\n  id\n  userId\n  isInternalIp\n  isLogRocket\n  isLogin\n  isBusiness\n  isActiveBusinessCart\n  ...UserMenu_viewer\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '52a3bf6e94af8a20c7bf51ba32a8fca5';
module.exports = node;
